import { Accordion } from '@zaiusinc/hera';
import React, { useState, useEffect, ReactNode } from 'react';
import styles from './CustomSettingsSection.module.sass';

interface Props {
  title: string;
  sectionKey: string;
  isOpen?: boolean;
  onToggle?: () => void;
  showTopBorder?: boolean;
  children: ReactNode;
}

export const CustomSettingsSection = ({
  title,
  sectionKey,
  isOpen = false,
  onToggle,
  showTopBorder = false,
  children,
}: Props) => {
  const [sectionOpen, setSectionOpen] = useState(isOpen);

  useEffect(() => {
    setSectionOpen(isOpen);
  }, [isOpen]);

  const handleClick = () => {
    // Only open the section if it's closed (match app form section behavior)
    // Don't close when clicking on an already open section
    if (!sectionOpen && onToggle) {
      onToggle();
    }
  };

  const className = showTopBorder
    ? `${styles.section} ${styles.withTopBorder}`
    : styles.section;

  return (
    <Accordion
      className={className}
      minimal={true}
      isOpen={sectionOpen}
      header={title}
      onClick={handleClick}
    >
      <div className={styles.content}>
        {children}
      </div>
    </Accordion>
  );
};
